var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-passage-view flex-between-wrapper" },
    [
      _c("img", {
        staticClass: "feature-image",
        attrs: { src: "/assets/app/class/quiz-frame-bg.png" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "premium-passage-view" }, [
        _c("h3", { staticClass: "view-title" }, [
          _vm._v("Seamlessly align ReadTheory with your existing curriculum."),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "view-description" }, [
          _vm._v(
            "With Premium you can use ReadTheory for a whole-class lesson by assigning a specific passage from the library! Allow students to work in groups, take a common assessment, or hold a class discussion on it."
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-wrapper" },
          [
            _c("primary-button", { on: { click: _vm.handleClickPlan } }, [
              _vm._v("Choose your plan"),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }